import ClientSelection from './js/ClientSelection';

export default ClientSelection;
